import { heroChips, siteName } from "@/mocks/content";

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[92vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20cinematic%20scene%20with%20warm%20amber%20and%20deep%20terracotta%20tones%2C%20soft%20draped%20fabric%20and%20drifting%20light%20rays%2C%20moody%20dramatic%20shadows%2C%20artistic%20film%20grain%20texture%2C%20elegant%20editorial%20composition%2C%20no%20people%2C%20quiet%20intimate%20atmosphere&width=1920&height=1080&seq=ssl-hero-main&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center pt-28 pb-24">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 text-background-50 text-xs md:text-sm tracking-[0.2em] border border-background-50/25">
          <i className="ri-play-circle-line"></i>
          {siteName} · 剧情解析站
        </span>

        <h1 className="mt-6 font-heading text-background-50 text-3xl md:text-5xl lg:text-[3.5rem] font-bold leading-[1.2]">
          善良的嫂子 · 结局解析与人物关系全梳理
        </h1>

        <p className="mt-5 text-background-100/90 text-sm md:text-lg leading-relaxed max-w-2xl mx-auto">
          从大结局走向到人物动机，从剧情脉络到角色介绍，一页看懂这段家庭伦理与心理纠葛背后的故事。
        </p>

        <div className="mt-7 flex flex-wrap justify-center gap-2">
          {heroChips.map((chip) => (
            <span
              key={chip}
              className="px-3 py-1 rounded-full text-xs md:text-sm text-background-50 bg-background-50/10 border border-background-50/20"
            >
              {chip}
            </span>
          ))}
        </div>

        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#ending"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-sm md:text-base font-medium whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer w-full sm:w-auto"
          >
            <i className="ri-book-marked-line"></i> 直击大结局解析
          </a>
          <a
            href="#relations"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-sm md:text-base font-medium whitespace-nowrap bg-background-50/10 text-background-50 border border-background-50/30 hover:bg-background-50/20 transition-colors cursor-pointer w-full sm:w-auto"
          >
            <i className="ri-group-line"></i> 查看人物关系
          </a>
        </div>
      </div>

      <a
        href="#overview"
        className="absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 text-background-50/80 hover:text-background-50 text-xs cursor-pointer animate-soft-float"
      >
        <span>向下浏览</span>
        <i className="ri-arrow-down-line text-lg"></i>
      </a>
    </section>
  );
}